module.exports = __webpack_public_path__ + "img/title-3.e7c78218.png";